import React from "react";
import ReactDOM from "react-dom";
import EmbedController from "../embed/EmbedController";
import ProductBuilder from "./components/ProductBuilder";
import { UrlDataController } from "./components/dataManagers/UrlDataController";
import { HandleGeneralErrors } from "./components/errorHandling/handleErrors.js";

import "../globals.scss";

beginExperience();

function beginExperience() {
  // Direct visits stay in the configurator. /live and /dev used to bounce to the Woo storefront.
  if (EmbedController.isEmbedded) {
    document.addEventListener("InitEmbed", reactRender);
  } else {
    reactRender();
  }
}

function reactRender() {
  ReactDOM.render(
    <React.StrictMode>
      <HandleGeneralErrors>
        <UrlDataController>
          <ProductBuilder />
        </UrlDataController>
      </HandleGeneralErrors>
    </React.StrictMode>,
    document.getElementById("react-root")
  );
}
